var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orderDetailsPanel"},[_c('OrderDetails',{attrs:{"order":_vm.order}}),_c('div',{staticClass:"disclaimer"},[_vm._v(_vm._s(_vm.$t('subscriptions.plans.disclaimer')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }